export default "__VITE_ASSET__DBuBEQKi__"